import React, { Component } from "react";
import "../skins_15.2.0/shaka/videojs.css";
import videojs from "video.js";
import "../components_15.2.0/es/nuevo";
import "../components_15.2.0/es/playlist.js";
import "../components_15.2.0/es/videojs.thumbnails.js";


export default class VideoJs extends Component {

  componentDidMount() {
    const videoJsOptions = {
      controls: true,
	  preload: "auto",
	  autoplay:false,
	  playsinline: "true",
	  crossorigin:"anonymous",
	  poster: "//nvdata.b-cdn.net/media/big_buck.jpg",
    };

	  const nuevo_options = {
		video_id:"Nuevo E3",
		url: "https://www.nuevodevel.com/react/example3/",
		title: "Video.js Playlist React 18",
		pipButton:false
	  }

    // instantiate Video.js


	  
	  const player = this.player =	videojs(this.videoNode, videoJsOptions, function onPlayerReady() {
		
			console.log('Player ready!');
		});

		this.player.nuevo(nuevo_options);
	    player.thumbnails({responsive:true });
		player.uniquePlaylist="po1";
		
		const myPlaylist = [
	  {
	    sources: [
	      {
		src: "//opencdn.b-cdn.net/video/big_buck_480.mp4",
		type: "video/mp4"
	      }
	    ],
	    title: "Big Buck Bunny<br>by Blender Foundation",
	    thumb: "//opencdn.b-cdn.net/playlist/big_buck_thumb.jpg",
	    duration: "09:56",
		url: "https://www.nuevodevel.com/react/example3/",
	    slideImage: "//nvdata.b-cdn.net/media/big_buck_slide_160.jpg"
	  },
	  {
	    sources: [
	      {
		src: "//opencdn.b-cdn.net/video/hls/santo/playlist.m3u8",
		type: "application/x-mpegURL"
	      }
	    ],
	    title: "Santorini - spectacular island",
	    thumb: "//opencdn.b-cdn.net/playlist/santorini.jpg",
	    duration: "02:21",
			url: "https://www.nuevodevel.com/react/example3/",
	    track: {
	      kind: "metadata",
	      src: "//opencdn.b-cdn.net/media/santorini_thumbs.vtt"
	    }
	  },
	  {
	    sources: [
	      {
		src: "//opencdn.b-cdn.net/video/hls/ski/playlist.m3u8",
		type: "application/x-mpegURL"
	      }
	    ],
	    title: "Winter fun in high mountains",
	    thumb: "//opencdn.b-cdn.net/playlist/ski.jpg",
		url: "https://www.nuevodevel.com/react/example3/",
	    duration: "01:49",
	    slideImage: "//nvdata.b-cdn.net/media/ski_slide_160.jpg"
	  },

	  {
	    sources: [
	      {
		src: "//opencdn.b-cdn.net/video/hls/tears/playlist.m3u8",
		type: "application/x-mpegURL"
	      }
	    ],
	    title: "Tears of Steel<br>(CC) Blender Foundation",
	    thumb: "//opencdn.b-cdn.net/playlist/tears.jpg",
		url: "https://www.nuevodevel.com/react/example3/",
	    duration: "12:14",
	    tracks: [
	      {
		kind: "captions",
		src: "//opencdn.b-cdn.netvideo/hls/tears/captions/steal_en.vtt",
		srlang: "en",
		label: "English",
		default: "1"
	      },
	      {
		kind: "captions",
		src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_de.vtt",
		srlang: "de",
		label: "German",
		default: "1"
	      },
	      {
		kind: "captions",
		src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_fr.vtt",
		srlang: "fr",
		label: "French",
		default: "1"
	      },
	      {
		kind: "captions",
		src: "//opencdn.b-cdn.net/video/hls/tears/captions/steal_es.vtt",
		srlang: "es",
		label: "Spanish",
		default: "1"
	      },
	      {
		kind: "chapters",
		src: "//opencdn.b-cdn.net/captions/steal_chapters.vtt",
		srclang: "en",
		label: "Chapters"
	      }
	    ]
	  },
	  {
	    sources: [
	      {
		src: "//opencdn.b-cdn.net/video/serenity_240.mp4",
		type: "video/mp4",
		res: "240",
		label: "240p"
	      },
	      {
		src: "//opencdn.b-cdn.net/video/serenity_360.mp4",
		type: "video/mp4",
		res: "360",
		label: "360p",
		default: true
	      },
	      {
		src: "//opencdn.b-cdn.net/video/serenity_480.mp4",
		type: "video/mp4",
		res: "480",
		label: "480p"
	      },
	      {
		src: "//opencdn.b-cdn.net/video/serenity_720.mp4",
		type: "video/mp4",
		res: "720",
		label: "720p"
	      }
	    ],
	    title: "Serenity Movie trailer",
	    thumb: "//nvdata.b-cdn.net/media/serenity_thumb.jpg",
	    duration: "02:13",
		url: "https://www.nuevodevel.com/react/example3/",
	    track: {
	      kind: "metadata",
	      src: "//opencdn.b-cdn.net/media/serenity-slide.vtt?v=11"
	    }
	  },
	  {
	    sources: [
	      {
		src: "//opencdn.b-cdn.net/video/animals_240.mp4",
		type: "video/mp4",
		res: "240",
		label: "240p"
	      },
	      {
		src: "//opencdn.b-cdn.net/video/animals_360.mp4",
		type: "video/mp4",
		res: "360",
		label: "360p",
		default: true
	      },
	      {
		src: "//opencdn.b-cdn.net/video/animals_480.mp4",
		type: "video/mp4",
		res: "480",
		label: "480p"
	      },
	      {
		src: "//opencdn.b-cdn.net/video/animals_720.mp4",
		type: "video/mp4",
		res: "720",
		label: "720p"
	      }
	    ],
	    title: "Discover the world's animals",
	    thumb: "//nvdata.b-cdn.net/media/animals_thumb.jpg",
	    duration: "03:03",
		url: "https://www.nuevodevel.com/react/example3/",
		slideImage: "//nvdata.b-cdn.net/media/animals_slide_160.jpg"
	  }
	];

	  
	  this.player.playlist(myPlaylist);

	

	 
	  document.addEventListener('click',function(e) {
		if(e.target.className==='ex') {
			let warn = document.querySelector('.exwarn');
			if(warn.className=='exwarn')  {
				document.querySelector('.exwarn').classList.add('exwarn-show');
			}
		} else {
			document.querySelector('.exwarn').classList.remove('exwarn-show');
		}
	  });


  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

   render() {
    return (
    <div>
	<header><a href="https://www.nuevodevel.com/nuevo/reactvue">Back to examples</a><a href="https://www.nuevodevel.com/nuevo/">Nuevo</a></header>  
	<div className="container">
		<h1>Video.js React Demo #3</h1>
		<h2>Featuring Nuevo plugin and unique playlist</h2>
	    <div className="btn-nav">
		<a className="exbtn" href="/react/example1/">Example1</a>
		<a className="exbtn" href="/react/example2/">Example2</a>
		<span className="exbtn exbtn-active">Example 3</span>
		</div>
	
		<div className="v-parent"><div className="v-child">
          <video ref={(node) => (this.videoNode = node)} className="video-js vjs-fill" />
		</div></div>

		<div className="vjs-companion"></div>

		<div className="desc">
		<p>Demo rendered in React.js version <b>19.2.7</b> </p>
		  <p>Presenting Video.js player v <b>8.23.9</b> with the Nuevo plugin v <b>15.2.0</b> and Shaka skin.</p>
		  <p>Unique playlist plugin allows to play a wide range of media files in various formats.</p>
		  <p>
			Each playlist item may include information about subtitles,
			chapters, progress bar thumbs, title, embed code, etc.
		  </p>
		<p className="break"></p>
		<p>We have prepared as many as <b>29 React</b> and <b>10 Next.js</b> examples covering plugins usage included in Nuevo Software.</p>
		<p> All examples are available to test and review source code through the <b>CodeSandbox</b> editor.</p>

		<div className="cols">
			<ul>
			<li className="ex">Basic Setup</li>
			<li className="ex">Nuevo playlist</li>
			<li className="ex">Nuevo playlist below the player</li>
			<li className="ex">Related videos & sharing options</li>
			<li className="ex">Subtitles - method #1</li>
			<li className="ex">Subtitles - method #2</li>
			<li className="ex">Chapters</li>
			<li className="ex">Audio playback</li>
			<li className="ex">Audio ID Tags plugin</li>
			<li className="ex">Custom language</li>
			<li className="ex">Changing video source</li>
			<li className="ex">VTT Thumnails over progress bar</li>
			<li className="ex">Filters plugin</li>
			<li className="ex">Skip Intro plugin</li>
			<li className="ex">News Ticker plugin</li>
		</ul>
		<ul>
			<li className="ex">Overlay plugin</li>
			<li className="ex">UpNext plugin</li>
			<li className="ex">More videos gallery</li>
			<li className="ex">Hls.js streaming handler</li>
			<li className="ex">Dash.js streaming handler</li>
			<li className="ex">Offline plugin</li>
			<li className="ex">Video events plugin</li>
			<li className="ex">Transcript plugin</li>
			<li className="ex">Vroll video ads</li>
			<li className="ex">VASTPro plugin</li>
			<li className="ex">VAST ads</li>
			<li className="ex">Chromecast plugin</li>
			<li className="ex">VR/360&deg; plugin</li>
			<li className="ex">React route example</li>
			
		 </ul>
		 </div>
		 <p className="break"></p>
         <h2>Next.js/React available examples</h2>
			 Rendered in Next.js version 15.0.3 and React 19.2.7.
		 <br/>
		 <div className="cols">	 
		 <ul>
			<li className="ex">Basic Setup with VTT Tthumbnails</li>
			<li className="ex">VTT progressbar thumbnails Demo</li>
			<li className="ex">News Ticker plugin</li>
			<li className="ex">Overlay plugin</li>
			<li className="ex">Vroll ads demo</li>
			<li className="ex">Nuevo playlist</li>
			<li className="ex">VAST Video ads demo</li>
			<li className="ex">VASTPro demo</li>
			<li className="ex">Google Ima Ads</li>
			<li className="ex">Chromecast plugin demo</li>
		 </ul>
		</div>


		<p className="break"></p>
		<p className="c900">Access to CodeSandbox examples is available for logged-in Nuevo Software Gold Plan users<br/>
		who decide to buy such service in the client area.</p>

		<p className="csb">
			<b>CodeSandbox</b> is a platform for application developers.<br/>
			It features an online code editor and a prototyping tool that runs in a web browser.<br/>
			With CodeSandbox, you can easily learn, experiment, debug, and test your apps.<br/>
			It's much easier to learn from CodeSandbox examples than from any written tutorials. 
			
		</p>


		</div>

     </div>

	 <div className="exwarn">
		 <div className="exclose">&times;</div>
		 Access to example source code is available<br/>
		 for logged Nuevo Software Gold Plan users<br/>
		who purchased such a service.
	 </div>		

	 </div>
	

    );
  }
}